import { render, staticRenderFns } from "./DistStartNew.vue?vue&type=template&id=4926796e"
import script from "./DistStartNew.vue?vue&type=script&lang=js"
export * from "./DistStartNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports